import axios from 'axios';
import { AVAILABLE_LOCALE } from '../constants/LocaleConstants';
export const fetchResourceBundle = (languageCode) => {
    return new Promise((resolve, reject) => {
        const config = {
            method: 'GET',
            url: AVAILABLE_LOCALE[languageCode].translationListUrl,
            headers: {
                'Access-Control-Allow-Origin': '*',
                'Access-Control-Allow-Methods': 'GET',
            },
        };
        axios(config)
            .then(function (response) {
            resolve({
                translations: response.data.translations,
                regionDataDetails: response.data.region,
                languageCode: response.data.languageCode,
                languageCodeId: response.data.languageCodeId,
            });
        })
            .catch(function (error) {
            reject(error);
        });
    });
};
